<script setup lang="ts">
// Parité V1 temporaire : /accueil rend la home V1 telle quelle (contenu +
// PersonnalBar en aside, comme App.vue le fait en mode v1) en attendant le
// vrai dashboard V2 — cf design-system/pages/accueil.md.
import HomePageV1 from '@/pages/HomePage.vue'
import PersonnalBar from '@/components/common/layout/PersonnalBar.vue'
import HomeActionsCard from '@/v2/components/home/HomeActionsCard.vue'
</script>

<template>
  <div class="flex w-full flex-col lg:flex-row lg:items-start">
    <div class="min-w-0 flex-1">
      <div class="p-4 md:p-6 md:pb-0">
        <HomeActionsCard />
      </div>
      <HomePageV1 />
    </div>
    <!-- max-h calé sur la zone visible du <main> : 100dvh moins le header h-14 d'ApyLayout -->
    <aside
      aria-label="Résumé personnel"
      class="order-last w-full shrink-0 border-t border-base-300 bg-base-100/80 lg:top-0 lg:w-72  lg:bg-transparent"
    >
      <PersonnalBar />
    </aside>
  </div>
</template>
